import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./PopularCollection.module.scss";

const PopularCollection = ({
  name,
  creator,
  collectionImage,
  images,
  total,
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container} onClick={() => navigate("/explore-collection")}>
      <div className={styles.imgContainer}>
        <div className={styles.left}>
          <img src={collectionImage} alt="collection-pic" />
        </div>
        <div className={styles.right}>
          {images.map((i, idx) => (
            <img src={i} key={idx} alt="collection-pics" />
          ))}
        </div>
      </div>

      <div className={styles.textContainer}>
        <h5>{name}</h5>
        <div className={styles.bottom}>
          <div className={styles.creator}>
            <img src={creator.img} alt={creator.name} />
            <p>{creator.name}</p>
          </div>
          <div className={styles.total}>
            <p>Total {total} items</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularCollection;
